module.exports = __webpack_public_path__ + "static/media/25.586adf06.jpg";